function isIPhone() {
	return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

// Reference:
// https://stackoverflow.com/questions/57776001/how-to-detect-ipad-pro-as-ipad-using-javascript
function isIOS() {
	if (/iPad|iPhone|iPod/.test(navigator.platform)) {
		return true;
	} else {
		return navigator.maxTouchPoints &&
			navigator.maxTouchPoints > 2 &&
			/MacIntel/.test(navigator.platform);
	}
}

function isIPad() {
	return /iPad/.test(navigator.userAgent);
}

function isIPadOS() {
	return navigator.maxTouchPoints &&
		navigator.maxTouchPoints > 2 &&
		/MacIntel/.test(navigator.platform);
}

export {
	isIPhone, isIOS, isIPad, isIPadOS
}